import {Indicator, Toast} from "mint-ui";
import axios from "axios";

export default {
	name: "MoneyShop",
	props: {
		dataList: Array,
		id: String,
		userInfo: Object | Array
	},
	data: function () {
		return {
			current_index: 0,
			contentHeight: 'auto',
			isActive:true
		}
	},
	mounted() {
		this.initHeight()
		window.addEventListener("resize", this.initHeight, false)
	},
	methods: {
		initHeight: function () {
			let windowHeight = window.innerHeight
			let bannerHeight = document.getElementById('banner').offsetHeight;
			let goodsClassHeight = this.$refs.goodsClass.offsetHeight;
			this.contentHeight = `${(windowHeight - bannerHeight - goodsClassHeight)}px`;
			// console.log(this.contentHeight)
		},
		changeClass: function (index) {
			this.current_index = index
		},
		reload() {
			this.isActive=false;
			this.$nextTick(()=>{
				this.isActive=true;
			})
		},
		showInfo(index) {
			let goods = this.dataList[this.current_index].list[index];
			let goodsInfo = {
				showInfoGoodsId: goods.id,
				showInfoGoodsIcon: goods.icon,
				showInfoGoodsName: goods.name,
				showInfoGoodsDes: `获得：${goods.name}*${goods.item_count}`,
				showInfoGoodsPrice: goods.price,
				showInfoPriceType: 2,
				showInfoConfirm: this.buyItem
			}
			this.$parent.showInfo(goodsInfo)
		},
		buyItem(goodsId) {
			let _this = this
			Indicator.open({
				spinnerType: 'snake'
			});
			let parentData = this.$parent.$data;
			let param = new FormData();

			param.append("game", parentData.game);
			param.append("publisher", parentData.publisher);
			param.append("server_id", parentData.server_id);
			param.append("role_id", parentData.role_id);
			param.append("plan_id", this.id);
			param.append("id", goodsId);

			axios.post(
				`${this.$global.baseUrl}send-goods.html`,
				param
			).then(function (response) {
				Indicator.close();
				let data = response.data;
				if (data.code > 0) {
					if (_this.userInfo[goodsId]) {
						_this.userInfo[goodsId] = _this.userInfo[goodsId] + 1;
					} else {
						_this.userInfo[goodsId] = 1
					}
					_this.reload()
					Toast('购买成功，物品已发送到邮箱。');
				} else {
					console.log(data.msg);
					Toast(data.msg);
				}
			}).catch(function (error) {
				console.log(error);
				Indicator.close();
				Toast(error);
			});

			setTimeout(() => {
				Indicator.close();
			}, 2000);
		}
	}
}